/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import ZoneEnum from 'astro/enum/zone';

import PlanetZone from 'astro/server/zone/planet';
import PlatformZone from 'astro/server/zone/platform';


export default class
{
  constructor (parent, zones)
  {
    this.collection = new Map();

    for (const cass of zones.values())
    {
      this.collection.set(cass.id, this.__initializeZone__(cass, parent));
    }
  }


  __initializeZone__ (cass, parent)
  {
    switch (cass.type)
    {
      case ZoneEnum.Planet:   return new PlanetZone(cass, parent);
      case ZoneEnum.Platform: return new PlatformZone(cass, parent);
    }

    throw new Error('Unsupported zone type.');
  }


  setup ()
  {
    for (const zone of this.collection.values())
    {
      zone.getSector().getZones().insert(zone);
    }

    for (const zone of this.collection.values())
    {
      zone.setup();
    }
  }


  install ()
  {
    for (const zone of this.collection.values())
    {
      zone.install();
    }
  }


  getOne (coords)
  {
    return this.collection.get(coords.toString());
  }


  getAll ()
  {
    return this.collection.values();
  }


  getPlatform (coords)
  {
    const zone = this.getOne(coords);

    return (zone && zone.isPlatform()) ? zone : null;
  }


}
